'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var appearanceTransform = 'translateX(0)',
        appearanceOpacity = 1,
        cursor = 'pointer';

    if (this.props.disabled) {
        appearanceOpacity = 0.2;
        cursor = 'not-allowed';
        theme.color = theme.checkedColor = theme.disabledColor;
        theme.hoverColor = theme.checkedHoverColor = theme.disabledColor;
    }

    if (this.props.checked) {
        theme.background = theme.checkedBackground;
        theme.switcherBackground = theme.checkedSwitcherBackground;
        appearanceTransform = 'translateX(100%)';
    }

    var label = {
        transition: 'color ' + theme.transitionDuration + ' ' + theme.transitionFunction,
        color: theme.color,
        fontSize: theme.fontSize,
        lineHeight: theme.lineHeight,
        textWrap: 'none',
        whiteSpace: 'nowrap',
        wordWrap: 'normal',
        display: 'inline-block',
        verticalAlign: 'middle',
        cursor: cursor,
        userSelect: 'none',

        '&:hover': {
            color: theme.hoverColor
        }
    };

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            fontSize: 0,
            fontFamily: theme.fontFamily
        },
        field: {
            display: 'none'
        },
        label: label,
        labelChecked: Object.assign({}, label, {
            color: theme.checkedColor,
            '&:hover': {
                color: theme.checkedHoverColor
            }
        }),
        icon: {
            display: 'inline-block',
            verticalAlign: 'middle',
            position: 'relative',
            width: '40px',
            height: '14px',
            boxSizing: 'border-box',
            borderRadius: '100px',
            background: theme.background,
            opacity: appearanceOpacity,
            cursor: cursor,
            transition: 'background ' + theme.transitionDuration + ' ' + theme.transitionFunction,
            marginRight: this.props.checkedLabel ? theme.gutter * 2 + 'px' : 0,
            marginLeft: this.props.unCheckedLabel ? theme.gutter * 2 + 'px' : 0,

            '&:before': {
                transition: 'transform ' + theme.transitionDuration + ' ' + theme.transitionFunction,
                display: 'block',
                content: '""',
                position: 'absolute',
                top: 'calc(50% - 11px)',
                left: 0,
                transform: appearanceTransform,
                width: '22px',
                height: '22px',
                borderRadius: '50%',
                background: theme.switcherBackground,
                boxShadow: theme.switcherBoxShadow
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        icon: (0, _aphroditeJss.css)(styleList.icon),
        label: (0, _aphroditeJss.css)(styleList.label),
        field: (0, _aphroditeJss.css)(styleList.field),
        labelChecked: (0, _aphroditeJss.css)(styleList.labelChecked)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        background: theme.elDivider,
        switcherBackground: theme.elPrimary,
        fontSize: theme.tsNormal,
        fontFamily: theme.fontFamily,
        lineHeight: 1.5,
        color: theme.tLabel,
        switcherBoxShadow: '0 2px 4px 0 ' + theme.elShadowMain,

        // elAccent 0.5
        checkedBackground: 'rgba(139, 195, 74, 0.5);',
        checkedSwitcherBackground: theme.elAccent,
        switcherCheckedBoxShadow: '0 2px 4px 0 ' + theme.elShadowMain,
        checkedColor: theme.tFilled,
        checkedHoverColor: theme.tActive,

        hoverColor: theme.tInactive,

        disabledColor: theme.tDisabled
    };
};